import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import withLoading from '@pattern-library/with-loading';
import ManagedAccountBannerBody from './ManagedAccountBannerBody';  

const propTypes = {
    content: PropTypes.object,
    endpoint: PropTypes.string
};

const ManagedAccountBannerWithLoading = withLoading(ManagedAccountBannerBody, () => {return (<></>);});

function ManagedAccountBanner({ content, endpoint }) {
    const [isLoading, setIsLoading] = useState('init');
    const [bannerData, setBannerData] = useState({});

    useEffect(() => {
        fetchBannerData();
    }, []);

    const fetchBannerData = async () => {
        setIsLoading('pending');
        try{
            const res = await fetch(`${endpoint}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await res.json();
            setIsLoading('resolved');
            setBannerData(data);
        } catch (e) {
            setIsLoading('rejected');
        }
        return;
    };

    return (
        <ManagedAccountBannerWithLoading status={isLoading} content={content} {...bannerData} />
    );
}

ManagedAccountBanner.propTypes = propTypes;
export default ManagedAccountBanner;
